import '@src/styles/variables.scss'
import '@src/styles/imports.scss'
import '@src/styles/syncfusion.scss'

import PageLayout from './global/PageLayout.tsx'
import OidcProviderWrapper from './global/OidcProviderWrapper.tsx'
import { loadCldr, setCulture, setCurrencyCode } from '@syncfusion/ej2-base'

import * as n1 from '../node_modules/cldr-data/main/de/currencies.json'
import * as n2 from '../node_modules/cldr-data/main/de/timeZoneNames.json'
import * as n3 from '../node_modules/cldr-data/main/de/numbers.json'
import * as n4 from '../node_modules/cldr-data/main/de/ca-gregorian.json'
import * as s from '../node_modules/cldr-data/supplemental/currencyData.json'
import * as s2 from '../node_modules/cldr-data/supplemental/numberingSystems.json'
import { loadLocalization } from './translations/sf-translations.tsx'
import { useEffect } from 'react'
import 'dayjs/locale/de'
import dayjs from 'dayjs'

loadCldr(n1, n2, n3, n4, s, s2)
loadLocalization()
dayjs.locale('de')

const App = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setCulture('de')
      setCurrencyCode('EUR')
    }
  }, [])
  return (
    <OidcProviderWrapper>
      <PageLayout />
    </OidcProviderWrapper>
  )
}

export default App
